import script from "./selectMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./selectMenu.vue?vue&type=script&setup=true&lang=js"

import "./selectMenu.vue?vue&type=style&index=0&id=36518d81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36518d81"]])

export default __exports__